import axios from "axios";

export const LoginValue = (value) => ({
    type: "LogIn",
    payload: value,
});
  
export const sendForgotPasswordEmail = (email) => async (dispatch) => {
    dispatch({ type: 'FORGOT_PASSWORD_LOADING' });
    try {
      const url = `${process.env.REACT_APP_API_URL}/forgotPassword`;
      const response = await axios.post(url, { email }, {
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.status === 200) {
        dispatch({ type: 'FORGOT_PASSWORD_SUCCESS' });
      }
    } catch (error) {
      dispatch({
        type: 'FORGOT_PASSWORD_FAILURE',
        payload: error.response?.data?.message || 'Something went wrong',
      });
    }
};
